'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserFlag } from '../../Entities/User/UserFlag';
import { UserFlagCollection } from '../../Collections/User/UserFlagCollection';

export class UserFlagRepository extends CoreRepository {
  public getUserFlagByColor(userId: number, flagColor: string, options: object = {}) {
    return this.webAPI.getUserFlagByColor(userId, flagColor, options).then((response) => {
      const item = new UserFlag();
      item.hydrate(response);

      return item;
    });
  }

  public getUserFlags(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserFlags(userId, options).then((response) => {
      const collection = new UserFlagCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserFlag();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
